/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_AgentsInputs */

const en_cad_compare_row_agents = /** @type {(inputs: Cad_Compare_Row_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agent control`)
};

/**
* | output |
* | --- |
* | "AI agent control" |
*
* @param {Cad_Compare_Row_AgentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_agents = /** @type {((inputs?: Cad_Compare_Row_AgentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_AgentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_agents(inputs)
});
export { cad_compare_row_agents as "cad.compare.row_agents" }